/* eslint-disable react/prop-types */
import React from 'react';
import CustomerDetail from '@components/customer/CustomerDetail';

function LoyaltyDetailScreen(props) {
  return <CustomerDetail {...props} />;
}

export default LoyaltyDetailScreen;
